import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import '../../content/css/PortfolioAnalysis/PortfolioAnalysis.css';
import DocumentsTable from './DocumentsTable';

export default class PortfolioAnalysisDocuments extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Panel className="documents">
                <DocumentsTable
                    basePathForLinks={this.props.basePathForLinks}
                    showBreaches={false}
                    reportId={this.props.reportId}
                    items={this.props.items}
                    hideContractType={this.props.hideContractType} />
            </Panel>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AnalysisReports/PortfolioAnalysisDocuments.js